exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{box-sizing:border-box}body,button,html{margin:0;padding:0}button{border:0;background:none;font-size:100%;vertical-align:baseline;font-family:inherit;font-weight:inherit;color:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-smoothing:antialiased}body,button{-webkit-font-smoothing:antialiased;-moz-font-smoothing:antialiased}body{font:14px Helvetica Neue,Helvetica,Arial,sans-serif;line-height:1.4em;background:#f5f5f5;color:#4d4d4d;min-width:230px;max-width:550px;margin:0 auto;font-smoothing:antialiased;font-weight:300}button,input[type=checkbox]{outline:0}a{color:#304ffe}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./website/index.css
 ** module id = 396
 ** module chunks = 0
 **/